import React from 'react'
import { useQueryClient } from '@tanstack/react-query'
import RealTime from './RealTime'
import useDebouncedCallback from '@/v2/hooks/useDebouncedCallback'

const RTFinance = ({ patientId }) => {
  const queryClient = useQueryClient()

  const handleEvent = useDebouncedCallback(({ action, subject, data }) => {
    queryClient.invalidateQueries({
      queryKey: ['PatientFinanceInfo', patientId],
      cancelRefetch: true,
    })

    queryClient.invalidateQueries({
      queryKey: ['PatientFinancePaymentMethods', patientId],
      cancelRefetch: true,
    })

    queryClient.invalidateQueries({
      queryKey: ['PaymentPlans', patientId],
      cancelRefetch: true,
    })

    if (data?.payment_plan_id) {
      queryClient.invalidateQueries({
        queryKey: ['PaymentPlanInvoices', patientId, data.payment_plan_id],
        cancelRefetch: true,
      })

      queryClient.invalidateQueries({
        queryKey: [
          'PaymentPlanAwaitingProcesses',
          patientId,
          data.payment_plan_id,
        ],
        cancelRefetch: true,
      })
    }
  }, 500)

  return (
    <RealTime
      channel="PatientProfile::FinanceChannel"
      onEvent={handleEvent}
      patientId={patientId}
    />
  )
}

export default RTFinance
